import LanguageLocales from '@helsenorge/core-utils/constants/languages';
import enGB from '../resources/Uthopp.en-GB.json';
import nbNO from '../resources/Uthopp.nb-NO.json';
export const getResources = (language) => {
    switch (language) {
        case LanguageLocales.ENGLISH:
            return enGB;
        case LanguageLocales.NORWEGIAN:
        default:
            return nbNO;
    }
};
